import { render, staticRenderFns } from "./AllData.vue?vue&type=template&id=30399825&scoped=true&"
import script from "./AllData.vue?vue&type=script&lang=js&"
export * from "./AllData.vue?vue&type=script&lang=js&"
import style0 from "./AllData.vue?vue&type=style&index=0&id=30399825&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30399825",
  null
  
)

export default component.exports